import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AbstractDataServiceV2} from 'src/app/modules/core/service/v2/dataservice/abstractDataServiceV2';
import {CustomizeHttpUrlGenerator} from 'src/app/store/core/url/customizeHttpUrlGenerator';
import {ConsultationCategoryModel} from '../../../api/model/consultationCategory.model';
import {ConsultationCategoryConverter} from '../../../api/model/converter/consultationCategory.converter';


@Injectable({providedIn: 'root'})
export class ConsultationCategoryDataService extends AbstractDataServiceV2<ConsultationCategoryModel, ConsultationCategoryConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: ConsultationCategoryConverter) {
        super('ConsultationCategory', http, httpUrlGenerator, logger, config, converter);
    }
}
